const inject = ['$stateParams', 'addresses', '$scope', 'editShippingModal', 'toastService'];

function SelectShippingControllerFactory($stateParams, addresses, $scope, editShippingModal, toastService) {
  class SelectShippingController {
    constructor(_selectedId, _addresses) {
      this.selectedId = _selectedId;
      this.addresses = _addresses;
      this.submitting = false;
    }

    $onInit() {
      this.useForAll = true;
    }

    submit(selectedAddressId, useForAll) {
      this.submitting = true;

      return editShippingModal.submit(selectedAddressId, useForAll)
        .then($scope.$close)
        .then(() => toastService.translate.success('TOAST_CHANGE_SHIPPING_SUCCESS'))
        .catch(() => toastService.translate.danger('TOAST_CHANGE_SHIPPING_DANGER'))
        .finally(() => {
          this.submitting = false;
        });
    }
  }
  return new SelectShippingController($stateParams.shipment.shippingAddressId, addresses);
}

SelectShippingControllerFactory.$inject = inject;

angular.module('msi.shipping.select')
  .controller('SelectShippingController', SelectShippingControllerFactory);

module.exports = SelectShippingControllerFactory;
